import { Box, Card, CardContent, Grid, Tooltip } from "@mui/material";
import { Clear, RestoreFromTrash, Search } from "@mui/icons-material";
import { GridActionsCellItem, GridRowId, GridRowModel, GridSortDirection, GridSortModel } from "@mui/x-data-grid";
import { useEffect, useMemo, useState } from "react";
import AutoComplete from "../../../components/hookForms/autoComplete";
import { Button } from "@mui/material";
import { Container } from "../../../theme/globalStyles";
import DataTable from "../../../components/dataTable";
import IGenericResult from "../../../interfaces/IGenericResult";
import InputNumber from "../../../components/hookForms/inputNumber";
import TextInput from "../../../components/hookForms/textField";
import messages from "../../../utils/messages";
import serviceConcessionaria from "../../../services/serviceConcessionaria";
import { toast } from "react-toastify";
import { useAuth } from "../../../context/global";
import { useForm } from "react-hook-form";
import DialogRestore from "./modal/dialogRestore";
import serviceClienteInstalacao from "@/services/serviceClienteInstalacao";

const HistoricoExclusaoInstalacao = (props: any) => {
  const { setTitlePage } = useAuth();

  useEffect(() => {
    setTitlePage("Histórico de Exclusão");
  }, [setTitlePage]);

  const [data, setData] = useState<any[]>([]);
  const [pageSize, setPageSize] = useState(100);
  const [page, setPage] = useState(0);
  const [filters, setFilters] = useState(null);
  const [rowCount, setRowCount] = useState(0);
  const [isLoading, setLoading] = useState(false);

  const [sortModel, setSortModel] = useState<GridSortModel>([
    {
      field: "",
      sort: "" as GridSortDirection,
    },
  ]);

  const [concessionariaDataOptions, setConcessionariaDataOptions] = useState<IGenericResult[]>([]);
  const [restoreState, setRestoreState] = useState({
    open: false,
    id: "",
    numeroInstalacao: "",
    nomeCliente: "",
  });


  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      numeroInstalacao: "",
      nomeCliente: "",
      concessionariaID: "",

    },

  });

  const actionColumns = useMemo(
    () => [
      {
        headerName: "Operações",
        field: "operations",
        type: "actions",
        width: 160,
        hide: false,
        getActions: (params: { id: GridRowId; row: GridRowModel }) => [
          <GridActionsCellItem
            icon={
              <Tooltip title="Restaurar instalação">
                <RestoreFromTrash />
              </Tooltip>
            }
            label="Restaurar instalação"
            onClick={() =>
              setRestoreState({
                open: true,
                id: params.row.historicoExclusaoInstalacaoID.toString(),
                numeroInstalacao: params.row.numeroInstalacao,
                nomeCliente: params.row.nomeCliente,
              })
            }
          />,
        ],
      },
    ],
    []
  );

  const columns = useMemo(
    () => [
      {
        headerName: "ID",
        field: "historicoExclusaoInstalacaoID",
        type: "number",
        identity: true,
        width: 70,
      },
      {
        headerName: "Instalação",
        field: "numeroInstalacao",
        type: "string",
        flex: 1,
      },
      {
        headerName: "Concessionaria",
        field: "nomeConcessionaria",
        type: "string",
        flex: 1,
      },
      {
        headerName: "Cliente",
        field: "nomeCliente",
        type: "string",
        flex: 1,
      },
      {
        headerName: "Usuario",
        field: "nomeUsuário",
        type: "string",
        flex: 1,
      },
      {
        headerName: "Exclusão",
        field: "dataExclusao",
        type: "datetime",
        flex: 1,
      },
      ...actionColumns,
    ],
    [actionColumns]
  );

  useEffect(() => {
    setConcessionariaData();
  }, []);

  const setConcessionariaData = async () => {
    serviceConcessionaria
      .getConcessionarias()
      .then((result) => {
        setConcessionariaDataOptions(result?.data);
      })
      .catch(() => {
        setConcessionariaDataOptions([]);
      });
  };

  const getAllWithFilters = async (filters: any) => {
    setData([]);
    setLoading(true);

    serviceClienteInstalacao
      .getWithFilterHistorico({
        ...filters,

      })
      .then((result) => {
        setData(result?.data.content);
        setRowCount(result?.data.numberOfElements);
      })
      .catch((err) => {
        toast.error(messages.getWithFilterError, err);
        setData([]);
        setRowCount(0);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(
    () => {
      if (props && props.location && props.location.state) {
        getAllWithFilters(props.location.state);
      } else {
        getAllWithFilters(filters);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [page, pageSize, sortModel]
  );

  const onSubmit = (values: any) => {
    const newFilters = {
      ...values,
      CurrentPage: page + 1,
      Take: pageSize,
      SortExpression: sortModel[0]?.field || "",
      SortDirection: sortModel[0]?.sort || "",
    };

    setFilters(newFilters);
    getAllWithFilters(newFilters);
  };


  useEffect(() => {
    if (props && props.location && props.location.state) {
      reset(props.location.state);
      setFilters(props.location.state);
      getAllWithFilters(props.location.state);
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [props]);

  const onClear = () => {
    reset({
      numeroInstalacao: "",
      nomeCliente: "",
      concessionariaID: "",

    });
    getAllWithFilters(null);
  };

  const onSuccessAction = () => {
    getAllWithFilters(filters);
  };

  return (
    <Container>
      <Card>
        <CardContent>
          <Box sx={{ mb: 2 }}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid container columnSpacing={2}>
                <Grid item md={12}>
                  <Grid container spacing={2}>
                    <Grid item md={2}>
                      <InputNumber
                        name="numeroInstalacao"
                        label="Instalação"
                        control={control}
                        error={errors}
                        decimalScale={0}
                        noThousandSeparator
                        maxLength={15}
                      />
                    </Grid>
                    <Grid item md={3}>
                      <TextInput
                        id="nomeCliente"
                        name="nomeCliente"
                        label="Cliente"
                        control={control}
                        error={errors}
                        maxLength={200}
                      />
                    </Grid>

                    <Grid item md={3}>
                      <AutoComplete
                        name="concessionariaID"
                        label="Concessionaria"
                        options={concessionariaDataOptions}
                        control={control}
                        error={errors}


                      />
                    </Grid>

                    <Grid item md={2}>
                      <Button
                        disableElevation
                        variant="contained"
                        color="warning"
                        fullWidth
                        style={{ margin: "16px 0px 8px 0px" }}
                        startIcon={<Search />}
                        type="submit"
                        disabled={isLoading}
                      >
                        Pesquisar
                      </Button>
                    </Grid>

                    <Grid item md={2}>
                      <Button
                        disableElevation
                        variant="outlined"
                        color="warning"
                        fullWidth
                        style={{ margin: "16px 0px 8px 0px" }}
                        startIcon={<Clear />}
                        onClick={onClear}
                      >
                        Limpar
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </Box>

          <Box sx={{ height: 450 }}>
            <DataTable
              columns={columns}
              rows={data}
              rowId={(row: GridRowModel) => row.historicoExclusaoInstalacaoID}
              rowCount={rowCount}
              isLoading={isLoading}
              onPageChange={(currentPage: number) => setPage(currentPage)}
              onPageSizeChange={(currentPageSize: number) => setPageSize(currentPageSize)}
              pageSize={pageSize}
              onSortModelChange={(model: GridSortModel) => setSortModel(model)}
            />
          </Box>

          <DialogRestore
            open={restoreState.open}
            data={{
              id: restoreState.id,
              open: restoreState.open,
              numeroInstalacao: restoreState.numeroInstalacao,
              nomeCliente: restoreState.nomeCliente,
            }}
            onClose={() => {
              setRestoreState({
                open: false,
                id: "",
                numeroInstalacao: "",
                nomeCliente: "",
              });
            }}
            onSuccess={onSuccessAction}
          />
        </CardContent>
      </Card>
    </Container>
  );
};

export default HistoricoExclusaoInstalacao;
